import { useState } from "react";
import WebLayout from "../layout/WebLayout";
import { useDispatch, useSelector } from "react-redux";
import * as authActions from "../store/action/auth";
import { toastMessage } from "../utils/Message";
import { useCities } from "../hooks/useCities";
import { useStates } from "../hooks/useStates";
import { SCHEME } from "../utils/Constants";
import { Link } from "react-router-dom";

function DDCRegistration() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [pincode, setPincode] = useState("");
  const [stateId, setState] = useState("");
  const [district, setDistrict] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        authActions.ddcRegistration(
          name,
          email,
          mobile,
          pincode,
          stateId,
          district
        )
      );

      if (response.status) {
        toastMessage(response.msg, "success", "top-center", 2000);
        setName("");
        setEmail("");
        setMobile("");
        setPincode("");
        setState("");
        setDistrict("");
      } else {
        toastMessage(response.msg, "danger", "top-center", 2000);
      }
    } catch (error) {
      toastMessage(error.message, "danger", "top-center", 5000);
    }
  };

  const { stateList, city } = useSelector((state) => state.menu);
  useStates();
  useCities(stateId);
  return (
    <WebLayout pageName={"DDCRegistration"}>
      <section className="contact py-20 overflow-hidden">
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-7">
              <div className="content-scroll">
                <h3 className="text-2xl text-center mb-5">Ardh Sainik Mall </h3>
                <h4 className="text-xl text-center mb-5">
                  Wholesale: Retail: Income: Pension
                </h4>
                <div className="text-center mb-10">
                  <Link to={SCHEME} className="btn btn-primary" target="_blank">
                    VIEW DDC ASM SCHEME PDF
                  </Link>
                </div>
                <h5 className="text-md bg-main-600 text-white p-10">
                  Para 1: Ardh Sainik Mall: by the Soldier for the Society.
                </h5>
                <p>
                  Today “Ardh Sainik Canteen” is present in each state of India
                  and therefore demand is increasing day by day. At present more
                  than 6000+ applications for Ardh Sainik Canteen (ASC) retail
                  stores by the Soldiers community, on the same time more than
                  57 applications for Abhhyam Stores Canteens (ACS) by the women
                  (civilian) also received. Moreover, expecting 20,000 more
                  applications from the around 60 lakhs Soldiers community and
                  society during next 2 years. Therefore, there is an urgent
                  need to create a solid stock and supply chain for smooth
                  procurement and stock supply at each District level. Hence,
                  proposed to set up one “Ardh Sainik Mall DDC (District
                  Distribution and Display Centre)” in each District in COFO
                  (Company Owned Franchise Operated) Model to manage smooth
                  supply chain along with discounted stores. Since, the Ardh
                  Sainik Mall DDC operation will be taken care by the company
                  itself, hence, following facility will be available at Ardh
                  Sainik Mall DDC:
                </p>
                <ul className="alpha_list mx-10">
                  <li className="text-gray-600">
                    High Discounted retail mall: Ardh Sainik Mall will do retail
                    discounted sales for the public. However, sales below
                    Rs.5000/- will be treated as retail sales.
                  </li>
                  <li className="text-gray-600">
                    Wholesale supplier for all brands: Multi-brand/categories
                    Mall and Ardh Sainik Mall will offer whole sale price for
                    the billing above Rs.5000/- will be get 5% additional
                    discount.
                  </li>
                  <li className="text-gray-600">
                    District Procurement Division: Ardh Sainik Mall will procure
                    the stock as per need of the district and will supply to all
                    ASC, ACS and MVS as per demand.
                  </li>
                  <li className="text-gray-600">
                    Unique Costumer loyalty program: To make Permanent cliental
                    base a Unique costumers loyalty program introduced i.e.
                    Income and Pension on routine shopping.
                  </li>
                  <li className="text-gray-600">
                    Training and Education Center for retail and Marketing: A
                    training and education center will be developed to guide and
                    educate the all-Stores Mangers as well as regular session
                    for marketing of “Kharidari se Pension” a customer loyalty
                    program.
                  </li>
                  <li className="text-gray-600">
                    Sales and Marketing Support: Marketing advisor team will
                    assist Ardh Sainik Mall.
                  </li>
                  <li className="text-gray-600">
                    Distribution of Abhhyam Brand all category: Ardh Sainik Mall
                    is also authorized as distributor of Abhhyam Brand also,
                    without any additional costing.{" "}
                  </li>
                  <li className="text-gray-600">
                    Distribution of Agricultures Products: To extend the Penson
                    scheme for each farmer, therefore, agricultural products
                    range will be added soon on the recommendation of the Ardh
                    Sainik Mall (DDC).{" "}
                  </li>
                  <li className="text-gray-600">
                    New registration authorization: New registration facility
                    will be allowed to Ardh Sainik Mall (DDC) office.{" "}
                  </li>
                  <li className="text-gray-600">
                    Own Liquor Brand: Planned to add owned liquor brand facility
                    at Ardh Sainik Mall in each District of State policy allowed
                    and Franchise owner interest.{" "}
                  </li>
                  <li className="text-gray-600">
                    Launch of IPO: In view of huge demand, it has been decided
                    to launch IPO during the next 3 years, and first shares
                    offer will be given to Ardh Sainik Mall (DDC).
                  </li>
                </ul>
                <h5 className="text-md bg-main-600 text-white p-10 mt-10">
                  Para 2: Ardh Sainik Mall: District Branch Model
                </h5>
                <p>
                  Total authority with transparency at each level to make it
                  more viable implementation for success of the project. Ardh
                  Sainik Mall DDC is offered COFO (Company Owned Franchise
                  Operated) model on the following terms and conditions.
                </p>
                <ul className="mx-10">
                  <li className="text-gray-600">
                    i. Ardh Sainik Mall DDC will be the branch of ADPL and
                    independently handle under the guidance of the company.
                  </li>
                  <li className="text-gray-600">
                    ii. Direct procurement authority.
                  </li>
                  <li className="text-gray-600">
                    iii. 80% of the total Margin will be retained by the
                    Franchise owner.
                  </li>
                  <li className="text-gray-600">
                    iv. Abhhyam Bazaar (Ardh Sainik Mall) is Retail and whole
                    sales stores.{" "}
                  </li>
                  <li className="text-gray-600">
                    v. B to B sales and supply option.{" "}
                  </li>
                  <li className="text-gray-600">
                    vi. E-com partner of Abhhyam.com
                  </li>
                  <li className="text-gray-600">
                    vii. Likely to utilized as Direct Sale counter in District
                    for MSME Manufacturer through{" "}
                    <Link to="https://indianmsme.org/">
                      www.IndianMSME.org.
                    </Link>
                  </li>
                  <li className="text-gray-600">
                    viii. Entitled for 10% of each new registration and
                    agreement.{" "}
                  </li>
                  <li className="text-gray-600">
                    ix. Other operation recurring cost, such as staff, logistics
                    and all other will be bear by the franchise itself.
                  </li>
                  <li className="text-gray-600">
                    x. Sales and purchase will be done by the ASC Software only.
                  </li>
                  <li className="text-gray-600">
                    xi. Independent Branch Bank account of ADPL will be opened
                    for smooth operation at Branch level.{" "}
                  </li>
                  <li className="text-gray-600">
                    xii. In view of IPO planning, 250 shares of the ADPL will be
                    allotted to the Franchise owner, against the investment of
                    Rs.25 lakhs. However, 20% of invested amount will provide
                    the following benefits for 5 years:
                    <ul className="alpha_list mx-10">
                      <li className="text-gray-600">
                        Franchise Fee for 5 years.
                      </li>
                      <li className="text-gray-600">
                        Abhhyam Brand District Distributorship.
                      </li>
                      <li className="text-gray-600">
                        Lifetime software support
                      </li>
                      <li className="text-gray-600">
                        Lifetime marketing support
                      </li>
                      <li className="text-gray-600">Legal support</li>
                      <li className="text-gray-600">No GST Liability</li>
                      <li className="text-gray-600">
                        GST Return support by HO
                      </li>
                      <li className="text-gray-600">
                        Lifetime 100% benefits of allocated 250 shares through
                        IPO or even can re-sale.{" "}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-5 "
              style={{ position: "sticky", top: "20px" }}>
              <div
                className="contact-box border border-gray-100 rounded-10 px-20 py-10"
                style={{ backgroundColor: "#ecfff5" }}>
                <form onSubmit={handleSubmit} method="post">
                  <h6 className="mb-5 mt-5">
                    Ardh Sainik Mall DDC Registration
                  </h6>
                  <h6 className="mb-2 text-md text-gray-800">
                    केवल अर्ध सैनिक मॉल डीडीसी के लिए पंजीकृत
                  </h6>
                  <h6 className="mb-5 text-md text-gray-800">
                    Registered only for Ardh Sainik Mall DDC
                  </h6>
                  <div className="row gy-2">
                    <div className="col-md-6">
                      <label
                        for="name"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                        Name
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="common-input px-10"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        for="email"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                        Email
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>
                      <input
                        type="email"
                        className="common-input px-10"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        for="mobile"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                        Mobile Number
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>
                      <input
                        type="number"
                        className="common-input px-10"
                        id="mobile"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        placeholder="Enter your mobile number"
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        for="picode"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                        Pin Code
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>
                      <input
                        type="number"
                        className="common-input px-10"
                        id="pincode"
                        value={pincode}
                        onChange={(e) => setPincode(e.target.value)}
                        placeholder="Enter your pin code"
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        for="state"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                        State
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>
                      <select
                        className="common-input px-10"
                        value={stateId}
                        onChange={(e) => setState(e.target.value)}>
                        <option value="" disabled selected>
                          Select State
                        </option>
                        {stateList.map((item) => (
                          <option value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label
                        for="district"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                        District
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>
                      </label>
                      <select
                        className="common-input px-10"
                        value={district}
                        onChange={(e) => setDistrict(e.target.value)}>
                        <option value="" disabled selected>
                          Select District
                        </option>
                        {city.map((item) => (
                          <option value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="form-check text-md"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop">
                        <input
                          className="form-check-input"
                          style={{ border: "1px solid #828282" }}
                          type="checkbox"
                          value=""
                        />
                        <label className="form-check-label">
                          I agree to the{" "}
                          <Link to="#">Terms and Conditions</Link>
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-12 mt-10">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-32 rounded-8">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div
            className="modal-content"
            style={{ maxWidth: "100%", width: "100%" }}>
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Terms and Conditions
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <h6 className="text-md mb-10">1. Eligibility Criteria</h6>
              <ol className="alpha_list">
                <li>
                  Only Micro, Small, and Medium Enterprises (MSMEs) as defined
                  under the Government of India's MSME Act are eligible to
                  register.
                </li>
                <li>
                  The registrant must be a manufacturer, not a reseller or
                  trader.
                </li>
                <li>
                  The enterprise must hold a valid Udyam Registration
                  Certificate.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">2. Registration Process</h6>
              <ol className="alpha_list">
                <li>
                  Applicants must provide accurate and up-to-date information,
                  including:
                  <ul>
                    <li>• Udyam Registration Number</li>
                    <li>• GSTIN</li>
                    <li>• PAN Card</li>
                    <li>• Business registration documents</li>
                    <li>• Proof of manufacturing facility (if required)</li>
                  </ul>
                </li>
                <li>
                  The platform reserves the right to verify the information and
                  request additional documents before approval.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                3. Order Handling, Billing, and Pricing
              </h6>
              <ol className="alpha_list">
                <li>
                  All B2B orders will be booked by IndianMSME.org directly from
                  B2B buyers on behalf of the registered MSME manufacturers.
                </li>
                <li>
                  IndianMSME.org will issue invoices to buyers and collect
                  payments for these orders.
                </li>
                <li>
                  MSME manufacturers must quote ex-factory prices only while
                  listing products on the platform.
                </li>
                <li>
                  IndianMSME.org will arrange for the pickup of demanded stock
                  from the MSME manufacturer's location
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                4. Delivery Responsibility
              </h6>
              <ol className="alpha_list">
                <li>
                  IndianMSME.org will be responsible for delivering the products
                  to the buyers through:
                  <ul>
                    <li>
                      • District Distribution Centres (DDCs) if available, or
                    </li>
                    <li>
                      • Direct delivery from the manufacturer's location to the
                      buyer's address.
                    </li>
                  </ul>
                </li>
                <li>
                  Manufacturers must ensure that products are ready for pickup
                  at the agreed time and location to avoid delays.
                </li>
                <li>
                  Manufacturers will bear no responsibility for transportation
                  or delivery once the stock is picked up by IndianMSME.org
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                5. Product Listing and Fulfillment
              </h6>
              <ol className="alpha_list">
                <li>
                  Registered manufacturers must provide detailed product
                  descriptions, accurate pricing, and applicable specifications
                  for listing on the platform.
                </li>
                <li>
                  Manufacturers are responsible for ensuring the quality and
                  packaging of products before they are handed over for
                  delivery.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">6. Prohibited Activities</h6>
              <ol className="alpha_list">
                <li>
                  Misrepresentation of products, including false claims about
                  quality, origin, or certifications, is strictly prohibited.
                </li>
                <li>
                  Listing counterfeit or prohibited items as per Indian laws is
                  not allowed.
                </li>
                <li>
                  Using the platform for fraudulent activities or violating any
                  third-party rights will result in account termination.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">
                7. Platform Fees and Charges
              </h6>
              <ol className="alpha_list">
                <li>
                  IndianMSME.org may charge a commission or service fee for
                  facilitating orders and handling delivery. These fees will be
                  disclosed during registration.
                </li>
                <li>
                  All applicable charges will be deducted from the payments
                  collected from buyers before disbursing funds to the
                  manufacturer.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">8. Liabilities</h6>
              <ol className="alpha_list">
                <li>
                  IndianMSME.org acts as a facilitator between buyers and MSME
                  manufacturers. It is not liable for disputes arising directly
                  between these parties, though it may assist in resolving them
                  at its discretion.
                </li>
                <li>
                  Manufacturers remain solely responsible for the quality of
                  their products.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">9. Data Usage and Privacy</h6>
              <ol className="alpha_list">
                <li>
                  Manufacturers agree to IndianMSME.org using their business
                  information for marketing, analytics, and operational
                  purposes, as per the platform's Privacy Policy.
                </li>
                <li>
                  Sensitive information will be protected and not shared with
                  unauthorized third parties.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">10. Indemnity</h6>
              <p>
                Manufacturers agree to indemnify and hold IndianMSME.org
                harmless against any claims, damages, or legal proceedings
                arising out of their products, delivery issues, or violations of
                these terms.
              </p>
              <h6 className="text-md mt-10 mb-10">11. Termination</h6>
              <ol className="alpha_list">
                <li>
                  Manufacturers may terminate their registration by providing a
                  written request, subject to the settlement of any outstanding
                  dues or obligations.
                </li>
                <li>
                  IndianMSME.org reserves the right to terminate accounts for
                  breach of terms, non-compliance, or inactivity.
                </li>
              </ol>
              <h6 className="text-md mt-10 mb-10">12. Dispute Resolution</h6>
              <p>
                Any disputes will be subject to arbitration under Indian laws,
                with the venue in [City], India.
              </p>
              <h6 className="text-md mt-10 mb-10">13. Amendments</h6>
              <p>
                IndianMSME.org reserves the right to amend these terms at its
                discretion. Manufacturers will be notified of significant
                changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default DDCRegistration;
